var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("仪表盘")])]),_c('div',[_vm._v(" 这是自动化的基础页面。 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }